Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.default = clearInterval.bind(globalThis);
